import api from "./api";

export const managerLodGrpListApi = async () => {
  const res = await api({
    method: "get",
    url: "lod/lodList",
  });

  return res;
};

// 대시보드
export const dashbordApi = async (lodNo: string) => {
  const res = await api({
    method: "get",
    url: `home/dashboard/${lodNo}`,
  });

  return res;
};

//일자별 정보 조회
export const dayPayInfApi = async ({
  lodNo,
  dayDt,
}: {
  lodNo: string;
  dayDt: string;
}) => {
  const res = await api({
    method: "get",
    url: `home/dayPayInf/${lodNo}/${dayDt}`,
  });

  return res;
};

// 일자별체크인 리스트 조회
export const dayChkInListApi = async ({
  lodNo,
  dayDt,
}: {
  lodNo: string;
  dayDt: string;
}) => {
  const res = await api({
    method: "get",
    url: `home/dayChkInList/${lodNo}/${dayDt}`,
  });

  return res;
};
